<script>
import {
  MethodsTokenZamaniHesaplama,
  MethodsHeaderAvatar,
  MethodsStrFilterGet,
  MethodsWebSite,
  GenericComputed,
} from "@/state/helpers";
import { notificationMethods } from "@/state/helpers";
export default {
  name: "app",
  page: {
    // All subcomponent titles will be injected into this template.
    titleTemplate(title) {
      title = typeof title === "function" ? title(this.$store) : title;
      return title
        ? `${title} | ` + this.$config.APPLICATION_TITLE
        : this.$config.APPLICATION_TITLE;
    },
  },
  data() {
    return {
      WebSite:null,
      WebSiteConfig:null,
      UserTur:null
    }
  },
  mounted() {
    if (this.$cookie.get("ecampsus") != null) {
      this.TokenZamaniHesaplama();
    }
    // this.HeaderAvatar()
    // document.querySelector("html").setAttribute('dir', 'rtl')
  },
  watch: {
    /**
     * Clear the alert message on route change
     */
    // eslint-disable-next-line no-unused-vars
    $route(to, from) {
      // clear alert on location change
      this.clearNotification();
    },
  },
  methods: {
    ...MethodsTokenZamaniHesaplama,
    ...MethodsHeaderAvatar,
    ...MethodsStrFilterGet,
    ...MethodsWebSite,
    Get() {},
    clearNotification: notificationMethods.clear,
  },

  computed: {
    ...GenericComputed,
  },

  created() {
    let Page = {
      PageNumber: "1",
      PageSize: "10",
      PageDataSize: "1",
    }; 

    this.ActionsFilterGet({
      Service: "website",
      Page: Page,
      Filter: "&Url=" + window.location.protocol + "//" + window.location.host,
    }).then((res) => {


      if (res.Data.length > 0) { 
        this.WebSite = res.Data[0]
        window.$cookies.set("ecampuswebsite", res.Data[0].Id); 
                  this.ActionsFilterGet({
                Service: "configs",
                Page: Page,
                Filter: "&Websiteid=" + res.Data[0].Id,
              }).then((response) => {
                this.WebSiteConfig = response.Data[0]
              });
       // this.WebSite(res.Data[0].Id);
      } else {
        window.location = this.$config.LOGIN_URL;
      }
    });
  },
};
</script>

<template>
  <div id="app">
    <RouterView :WebSiteConfig="WebSiteConfig" :WebSite="WebSite" @UserTur="UserTur = $event" :UserTur="UserTur"/>
  </div>
</template>
